import iconAttach from "images/iconAttach.svg";
import trash from "images/trash.svg";
import { getReadableFileName } from "utils/functions";
import "./filesInfo.scss";

const FilesInfo = ({ hasFiles, ...props }) => {
  return (
    <div className="d-flex gap-2 flex-wrap flex-grow-1">
      {hasFiles && props.children
        ? props.children.map(({ file, handleClick, handleDelete }) => {
            return file && file !== -1 ? (
              <div key={file} className="d-flex align-items-center">
                <p
                  className="document-title d-flex align-items-center m-0"
                  target="_blank"
                  onClick={handleClick}
                >
                  <img alt="" src={iconAttach} className="me-1" />
                  {getReadableFileName(file)}
                </p>
                {handleDelete ? (
                  <button
                    type="button"
                    className="trash ms-1"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete();
                    }}
                    aria-label="Удалить файл"
                  >
                    <img alt="" src={trash} />
                  </button>
                ) : null}
              </div>
            ) : null;
          })
        : null}
    </div>
  );
};

export default FilesInfo;
